import * as lib from '~/dependencies';

export const integrationConfig = {
  AUTO_TASK: 56,
  ZENDESK: 18,
  ONE_PAGE_CRM: 58,
  SALESFORCE: 22,
  BULLHORN: 63,
  HUBSPOT_ID: 34,
  ZOHO_ID: 42,
  GO_HIGH_LEVEL_ID: 65,
  CUSTOM_URLS_ID: 59, // As in calllogs
  PIPEDRIVE_ID: 30,
  ACTIVE_CAMPAIGN_ID: 46,
  KEAP_ID: 60,
};

export function getFullNameFormatted(contactObj) {
  if (contactObj?.firstname && contactObj?.lastname)
    return `${contactObj.firstname} ${contactObj.lastname}`;

  if (contactObj?.firstname) return contactObj.firstname;

  return undefined;
}

export function getIntegrationInfo(integrationId, accountIntegrations) {
  const accountInfo = accountIntegrations
    .filter(e => Number(e.id) === Number(integrationId))
    ?.pop();

  if (accountInfo?.logo && accountInfo?.name) {
    return {
      logo: accountInfo.logo,
      name: accountInfo.name,
    };
  }
  return {};
}

const isInbound = direction => {
  if (direction?.includes('inbound')) {
    return true;
  }
  return false;
};

const getFullName = contact => {
  if (contact.lastname) {
    return `${contact.firstname} ${contact.lastname}`;
  }
  if (contact.firstname) {
    return contact.firstname;
  }
  return null;
};

export function getNumberByCallDirection(details) {
  if (!details.callDirection) return null;

  if (isInbound(details.callDirection)) {
    return String(details.from).replace(/\s+/g, '');
  }

  return String(details.to).replace(/\s+/g, '');
}

/**
 * Take a call details item, format the from/to based on call direction
 * Give priority to the number/name from the integration.
 * @returns returns a call details object or {}
 */
export function getDetailsFromTo(details, integrationId = 34) {
  if (!lib._.isObject(details) || lib._.isEmpty(details)) return {};

  const integration = details?.integrations
    ?.filter(e => Number(e.integration) === integrationId)
    .pop();
  const contactInfo = integration?.contact;

  // NOTE: Call direction different of Inbound/Outbound does not have contact integration
  if (!lib._.isEmpty(contactInfo)) {
    if (isInbound(details.callDirection) || isInbound(details.direction)) {
      return {
        ...details,
        fromName: getFullName(contactInfo) || details.fromName,
      };
    }
    return {
      ...details,
      toName: getFullName(contactInfo) || details.toName,
    };
  }

  return details;
}

export function getIntegrations(extra) {
  if (extra?.integrations?.length) {
    return extra.integrations;
  }
  return null;
}
